import { createSelector } from 'reselect'

const getSendgridSettingsOptions: SelectOptionsSelector = (state) =>
  state.sendgridSettings.sendgridSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const sendgridSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getSendgridSettingsOptions, (options) => options)
